/**
 * תוכן עמוד הנחיתה — קל לעריכה ולהחלפת צילומי מסך.
 * צילומי מסך: שימו קבצים תחת public/landing/showcase/ והפעילו useScreenshot: true עם שם הקובץ.
 */

/** נתיבי מוצר אמיתיים (מתואמים ל־Routes.jsx) */
export const LANDING_LINKS = {
  registerAgent: "/registeragent",
  login: "/login",
  companyLogin: "/company/login",
  contact: "/contact",
  vacationPackages: "/vacation-packages",
  flightsSearch: "/vacation-packages?category=flights",
  terms: "/termsAndConditions",
};

export const hero = {
  eyebrow: "פלטפורמה לסוכני נסיעות",
  title: "כל מה שצריך כדי למכור, לנהל ולסגור — במקום אחד",
  subtitle:
    "חיפוש מלונות, חבילות נופש וטיסות, הצעות מחיר ללקוח, מעקב הזמנות וכלי כספים — על גבי אותה מערכת שאתם כבר עובדים איתה ב־HotelsRiver.",
  primaryCta: "הרשמה כסוכן",
  secondaryCta: "כניסה לסוכנים",
  tertiaryCta: "חבילות נופש",
  tertiaryCtaSecondary: "חיפוש טיסות",
};

export const agentValueItems = [
  {
    id: "hotels",
    title: "חיפוש מלונות",
    text: "מנוע חיפוש, תוצאות מסודרות והמשך לפרופיל מלון וחבילות.",
  },
  {
    id: "packages",
    title: "חבילות נופש",
    text: "מסלול ייעודי לחבילות — מהחיפוש ועד הפרטים לפני מכירה.",
  },
  {
    id: "flights",
    title: "טיסות",
    text: "זרימת טיסות ציבורית וכלים במערכת הסוכן לעבודה מהירה.",
  },
  {
    id: "quotes",
    title: "הצעות מחיר",
    text: "שיתוף הצעה נקייה ללקוח — מלון, דינמי או טיסה לפי המקרה.",
  },
  {
    id: "orders",
    title: "ניהול הזמנות",
    text: "ריכוז הזמנות, סטטוסים ופעולות שגרתיות בלי לקפוץ בין מערכות.",
  },
  {
    id: "finance",
    title: "כספים ועמלות",
    text: "תמונה כלכלית, סיכומים וניהול תשלומים במקום אחד.",
  },
  {
    id: "clients",
    title: "עבודה מול לקוחות",
    text: "קישורים ללקוח, מסמכים והמשך טיפול — בצורה מסודרת.",
  },
  {
    id: "onePlace",
    title: "מקום אחד",
    text: "פחות כאוס בין אקסל, וואטסאפ ודפדפנים — יותר זרימה.",
  },
];

/**
 * mockupVariant — ויז'ואל מופשט מהממשק כשאין צילום; useScreenshot + imageFile כשיש קובץ ב־public.
 * פריטים בלי צילום אמיתי ב־public/landing/showcase/ לא רשומים ב־showcaseLandingItemIds —
 * הם נשמרים בהגדרות לעתיד ולא יוצגו בקרוסלת הנחיתה.
 */
export const showcaseItems = [
  {
    id: "hotel-search",
    badge: "חיפוש",
    title: "מנוע חיפוש מלונות",
    caption: "שדות יעד, תאריכים ותוצאות — נקודת הפתיחה לרוב המכירות.",
    mockupVariant: "hotelSearchPublicSite",
    /** צילום מ־public/landing/showcase/ — תמונה ראשונה (חיפוש מלונות ציבורי). */
    useScreenshot: true,
    imageFile: "hotel-search-public-rtl.png",
  },
  {
    id: "vacation",
    badge: "חבילות",
    title: "חבילות נופש",
    caption: "חוויית חיפוש ותוצאות ייעודית לחבילות — מתאים למוכר שחי מנופש.",
    mockupVariant: "vacation",
    /** תמונה שנייה בתיקיית המוקאפ (אותו נתיב). */
    useScreenshot: true,
    imageFile: "showcase-system-inside-rtl.png",
  },
  {
    id: "dashboard",
    badge: "דשבורד",
    title: "אזור סוכן",
    caption: "סדר יום, גישה מהירה לכלים ומבט על מה שדורש טיפול.",
    mockupVariant: "dashboard",
    /** צילום מסך דשבורד סוכן — קובץ תחת public/landing/showcase/ */
    useScreenshot: true,
    imageFile: "agent-area-dashboard-rtl.png",
  },
  {
    id: "orders",
    badge: "הזמנות",
    title: "ניהול הזמנות",
    caption: "רשימות, פירוט והמשך טיפול — פחות בלבול, יותר שליטה.",
    mockupVariant: "orders",
    useScreenshot: false,
    imageFile: "orders.png",
  },
  {
    id: "proposal",
    badge: "הצעה",
    title: "הצעת מחיר ללקוח",
    caption: "מסך שהלקוח רואה — מקצועי, ברור, סוגר פינות לפני השיחה.",
    mockupVariant: "proposal",
    useScreenshot: false,
    imageFile: "price-proposal.png",
  },
  {
    id: "finance",
    badge: "כספים",
    title: "סיכומים וכספים",
    caption: "מבט על עמלות, תנועות וארנק — בלי להתפזר בין דוחות.",
    mockupVariant: "finance",
    useScreenshot: false,
    imageFile: "finance.png",
  },
];

/** מזהי כרטיסים להצגה בעמוד הבית — רק עם קובץ PNG קיים בשורה (משתלב עם useScreenshot). */
const showcaseLandingItemIds = ["hotel-search", "vacation", "dashboard"];

export const showcaseItemsForLanding = showcaseItems.filter((item) =>
  showcaseLandingItemIds.includes(item.id)
);

export const benefits = [
  {
    title: "פחות זמן על עבודת ניירת",
    text: "המערכת מטפלת בתפעול, אתם מתמקדים בלקוחות. עושים מכירות.",
  },
  {
    title: "יותר סגירות נקיות",
    text: "הצעות ומסלולים שמסבירים את עצמם גם כשאתם לא ליד הטלפון.",
  },
  {
    title: "סדר שמורגש מול לקוח",
    text: "אותה מערכת לכל השלבים: נראה מצומצם ומקצועי, לא 'עוד טאב'.",
  },
  {
    title: "שליטה על התהליך",
    text: "מחיפוש ועד תשלום — עוקבים איפה כל עסקה עומדת.",
  },
];

export const audienceItems = [
  "סוכנים עצמאיים שרוצים ערימה אחת של כלים",
  "סוכנויות שמחפשות אחידות בין אנשי מכירות",
  "אנשי מכירות בתיירות שמכירים את הבעיה של 'עוד מערכת'",
  "מי שרוצה להיראות חד מול לקוח בלי להרים מותג טכנולוגי בעצמו",
  "מי שנמאס לו לרדוף אחרי גיליונות וקישורים באקראי",
];

export const trustPoints = [
  {
    title: "מוצר בשימוש שטח סוכנים",
    text: "נבנה סביב זרימות אמיתיות של חיפוש, הצעה והזמנה — לא דמו שיווקי.",
  },
  {
    title: "חיבור לספקים ולמנועים",
    text: "שכבת שירותים שמאחדת גישה לנתונים ולפעולות במקום קישורי ידניים.",
  },
  {
    title: "עדכונים שוטפים",
    text: "המערכת מתפתחת — שיפורים במנוע, במסכים ובכלי הסוכן.",
  },
];

export const steps = [
  { step: "1", title: "הרשמה", text: "פתיחת משתמש סוכן ואימות פרטים." },
  { step: "2", title: "התאמה", text: "כניסה לדשבורד, היכרות עם חיפוש והזמנות." },
  { step: "3", title: "מכירה ראשונה", text: "חיפוש, בניית הצעה ושיתוף ללקוח מהמערכת." },
];

export const faqItems = [
  {
    q: "זה מחליף את ה־GDS או ספק ספציפי?",
    a: "לא בהכרח — HotelsRiver מרכזת את העבודה מסביב לחיפוש, להצעות ולהזמנות שאתם כבר מנהלים.",
  },
  {
    q: "אפשר לראות את המערכת לפני התחייבות?",
    a: "כן — ההרשמה כסוכן היא נקודת הכניסה; לשאלות נוספות אפשר לפנות דרך צור קשר.",
  },
  {
    q: "מה עם לקוח קצה?",
    a: "יש מסלולים ציבוריים (חבילות / טיסות) ומסלולי שיתוף ללקוח — לפי סוג העסקה.",
  },
  {
    q: "האם יש תמיכה?",
    a: "קיימת תמיכה וליווי — כחלק מהערך לסוכנים פעילים במערכת.",
  },
];

/** HotelsRiver Business — פורטל נסיעות עסקיות לחברות וארגונים */
export const business = {
  eyebrow: "לחברות וארגונים",
  title: "HotelsRiver Business",
  text: "פורטל נסיעות עסקיות לחברות — חיפוש והזמנת חבילות, טיסות ומלונות לעובדים, ניהול עובדים והזמנות במקום אחד.",
  points: [
    "מחירים והטבות ייעודיים לחברות",
    "ניהול עובדים והרשאות תחת חשבון חברה אחד",
    "מעקב מרוכז אחרי הזמנות ונסיעות עסקיות",
  ],
  cta: "כניסה ל־HotelsRiver Business",
};

export const bottomCta = {
  title: "מוכנים לעבוד חכם יותר בשבוע הבא?",
  text: "הצטרפו לסוכנים שכבר מרכזים חיפוש, הצעות והזמנות ב־HotelsRiver.",
  primary: "להתחיל הרשמה",
  secondary: "דברו איתנו",
};

export const stickyCtaLabel = "הרשמה כסוכן";
